import { FC } from 'react'
import Pill from './Pill'
import ReviewInfo from './ReviewInfo'
import RequestCheckComments from './RequestCheckComments'
import { Status as Statuses, StatusProps } from './types/types'

import styles from './Status.module.scss'

const Status: FC<StatusProps> = ({ review, status, amount, name }) => {
  const { reviewer, created_at } = review || {}
  const hasStatusInfo = status && status !== Statuses.PENDING

  return (
    <div data-test-id="drop_request_status_container">
      <div className={styles.statusContainer}>
        <Pill status={status} approvedAmount={amount} />
        {hasStatusInfo && <ReviewInfo reviewerEmail={reviewer} reviewedDate={created_at} />}
      </div>
      {hasStatusInfo && <RequestCheckComments name={name} review={review} />}
    </div>
  )
}

export default Status
